var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info-edit" },
    [
      _c(
        "div",
        { staticClass: "info-edit-form" },
        [
          _c("field", {
            attrs: { name: "创建时间", label: "创建时间：", readonly: "" },
            model: {
              value: _vm.formInfo.createTime,
              callback: function ($$v) {
                _vm.$set(_vm.formInfo, "createTime", $$v)
              },
              expression: "formInfo.createTime",
            },
          }),
          _c("field", {
            attrs: {
              name: "人员类型",
              label: "人员类型",
              placeholder: "人员类型",
              readonly: "",
            },
            scopedSlots: _vm._u(
              [
                _vm.formInfo.jobType
                  ? {
                      key: "input",
                      fn: function () {
                        return [
                          _c(
                            "tag",
                            {
                              style: {
                                background: _vm.jobType.enums.find(
                                  (i) => i.key === _vm.formInfo.jobType
                                ).color,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.jobType.getValueByKey(
                                      _vm.formInfo.jobType
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
            model: {
              value: _vm.formInfo.jobType,
              callback: function ($$v) {
                _vm.$set(_vm.formInfo, "jobType", $$v)
              },
              expression: "formInfo.jobType",
            },
          }),
          _c("field", {
            attrs: {
              name: "手机号码",
              label: "手机号码：",
              type: "number",
              placeholder: "请输入手机号码",
              readonly: "",
              rules: [{ required: true, message: "请输入手机号码" }],
            },
            model: {
              value: _vm.formInfo.phone,
              callback: function ($$v) {
                _vm.$set(_vm.formInfo, "phone", $$v)
              },
              expression: "formInfo.phone",
            },
          }),
          _c("field", {
            attrs: {
              name: "姓名",
              label: "姓名",
              placeholder: "请输入姓名",
              readonly: "",
              rules: [{ required: true, message: "请输入法人名称" }],
            },
            model: {
              value: _vm.formInfo.name,
              callback: function ($$v) {
                _vm.$set(_vm.formInfo, "name", $$v)
              },
              expression: "formInfo.name",
            },
          }),
          _c("field", {
            attrs: {
              name: "身份证",
              label: "身份证：",
              placeholder: "请输入身份证",
              type: "idcard",
              maxLength: "18",
              readonly: "",
              rules: [{ required: true, message: "请输入法人身份证" }],
            },
            model: {
              value: _vm.formInfo.idCard,
              callback: function ($$v) {
                _vm.$set(_vm.formInfo, "idCard", $$v)
              },
              expression: "formInfo.idCard",
            },
          }),
          _c("field", {
            attrs: {
              name: "所在区域",
              label: "所在区域：",
              placeholder: "请选择所在区域",
              readonly: "",
              clickable: "",
              value: _vm.area,
              rules: [{ required: true, message: "请选择所在区域" }],
            },
          }),
          _c(
            "popup",
            {
              attrs: { position: "bottom" },
              model: {
                value: _vm.showArea,
                callback: function ($$v) {
                  _vm.showArea = $$v
                },
                expression: "showArea",
              },
            },
            [
              _c("Area", {
                attrs: { value: _vm.areaValue, "area-list": _vm.areaList },
                on: {
                  confirm: _vm.onConfirm,
                  cancel: function ($event) {
                    _vm.showArea = false
                  },
                },
              }),
            ],
            1
          ),
          _c("field", {
            attrs: {
              name: "详细地址",
              label: "详细地址：",
              placeholder: "请输入详细地址",
              readonly: "",
              type: "textarea",
              rules: [{ required: true, message: "请输入详细地址" }],
            },
            model: {
              value: _vm.formInfo.address,
              callback: function ($$v) {
                _vm.$set(_vm.formInfo, "address", $$v)
              },
              expression: "formInfo.address",
            },
          }),
          _vm._l(_vm.imageList, function (item, index) {
            return _c("field", {
              key: index,
              attrs: { name: "uploader", label: item.label + "：" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploader", {
                          attrs: {
                            maxCount: _vm.maxCount,
                            "after-read": (from) => _vm.afterRead(from, item),
                            readonly: "",
                            deletable: false,
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _c("div", { staticStyle: { height: "100px" } }),
      _c(
        "van-dialog",
        {
          attrs: { title: "不通过原因", "show-cancel-button": "" },
          on: {
            confirm: function ($event) {
              return _vm.sumbitAudit("2")
            },
          },
          model: {
            value: _vm.auditShow,
            callback: function ($$v) {
              _vm.auditShow = $$v
            },
            expression: "auditShow",
          },
        },
        [
          _c("field", {
            attrs: {
              label: "",
              type: "textarea",
              placeholder: "请输入不通过原因",
            },
            model: {
              value: _vm.auditMes,
              callback: function ($$v) {
                _vm.auditMes = $$v
              },
              expression: "auditMes",
            },
          }),
        ],
        1
      ),
      _vm.formInfo.auditStatus === "0"
        ? _c("fixedBottom", [
            _c("div", { staticClass: "btn-warp" }, [
              _c(
                "div",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      return _vm.changeDoctorAudit("1")
                    },
                  },
                },
                [_vm._v("通过")]
              ),
              _c(
                "div",
                {
                  staticClass: "btn btn2",
                  on: {
                    click: function ($event) {
                      return _vm.changeDoctorAudit("2")
                    },
                  },
                },
                [_vm._v("不通过")]
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "viewer",
              rawName: "v-viewer",
              value: _vm.viewerOptions,
              expression: "viewerOptions",
            },
          ],
          ref: "viewer",
          staticClass: "dialog-right",
        },
        _vm._l(_vm.imagesList, function (item, index) {
          return _c("img", { key: index, attrs: { "data-src": item } })
        }),
        0
      ),
      _c("Icon", {
        staticClass: "read-icon",
        attrs: { name: "browsing-history" },
        on: { click: _vm.handlePictureCardPreview },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }